import _ from "lodash";
import React, { useEffect, useState } from "react";
import AppGraphQl from "js/graphql/resolvers/programa.resolver";
import { GQLParamBuilder } from "../../../../../helpers";

const FEEDBACK_MSGS = {
  PROGRAMA_NOT_FOUND: "No se encontró el programa"
};

const fetchData = async (client, idPrograma, setFormParams) => {
  const formatData = true;
  try {
    const opBuilder = new GQLParamBuilder(client);

    const { getProgramaById } = AppGraphQl.queries;

    opBuilder.setOperation(getProgramaById);

    const variables = { idPrograma: parseInt(idPrograma) };

    opBuilder.setVariables({ ...variables });

    const result = await opBuilder.exec();

    if (!result.data && !result.data.getProgramas) {
      throw new Error(FEEDBACK_MSGS.PROGRAMA_NOT_FOUND);
    }

    let {
      data: {
        getProgramas: { itemsPagina: programas }
      }
    } = result;

    return programas.length > 0 ? programas[0] : undefined;
  } catch (error) {
    setFormParams(prev => ({
      ...prev,
      errors: error.message
    }));

    return null;
  }
};

export const useGetProgramas = ({ client, idPrograma, setFormParams }) => {
  const [programa, setPrograma] = useState([]);

  useEffect(
    () => {
      const getProgramas = async () => {
        if (!_.isNil(idPrograma)) {
          const programaFound = await fetchData(
            client,
            idPrograma,
            setFormParams
          );
          if (!_.isNil(programaFound)) {
            setPrograma(programaFound);
          }
        }
      };
      getProgramas();
    },
    [idPrograma]
  );

  return programa;
};
